/**
 * @generated SignedSource<<8556e3361b78170df1a744a20261f451>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PoiEditForm_poi$data = {
  readonly description: string | null;
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "PoiEditForm_poi";
};
export type PoiEditForm_poi$key = {
  readonly " $data"?: PoiEditForm_poi$data;
  readonly " $fragmentSpreads": FragmentRefs<"PoiEditForm_poi">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PoiEditForm_poi",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "type": "Poi",
  "abstractKey": null
};

(node as any).hash = "b540c0548d4ad64a092a16e020bf895e";

export default node;
